export default __webpack_public_path__ + "static/media/edelweiss-booksun.9ca11fbb.svg";